// utils/generateAnalyticsPdf.ts
import pdfMake from 'pdfmake/build/pdfmake'
import * as pdfFonts from 'pdfmake/build/vfs_fonts'
;(pdfMake as any).vfs = (pdfFonts as any).vfs

export const generateAnalyticsPDF = (data: any) => {
  const { summary, breakdowns, insights, dailyData, from, to } = data

  const watermarkBase64 =
    'data:image/png;base64,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'

  const docDefinition: any = {
    // push everything in a bit from the edge
    pageMargins: [40, 60, 40, 60],

    // 2) Register the image under a key:
    images: {
      watermark: watermarkBase64,
    },

    // 3) Draw it behind every page:
    background: (_currentPage: number, pageSize: any) => ({
      image: 'watermark',
      width: pageSize.width * 0.6, // scale to 60% of page width
      opacity: 0.1, // very faint
      alignment: 'center',
      margin: [0, pageSize.height / 3], // vertically centered-ish
    }),

    content: [
      // --- Title ---
      {
        text: 'Overview Analytics Report',
        style: 'header',
      },

      // --- Date Range ---
      {
        text: from
          ? `From ${new Date(from).toLocaleDateString()} to ${new Date(
              to
            ).toLocaleDateString()}`
          : 'All Time',
        style: 'dateRange',
        margin: [0, 0, 0, 20],
      },

      // --- Summary Table ---
      {
        text: 'Summary',
        style: 'sectionTitle',
        margin: [0, 10, 0, 6],
      },
      {
        table: {
          widths: ['*', '*'],
          body: [
            [
              { text: 'Metric', bold: true },
              { text: 'Value', bold: true },
            ],
            ['Total Valid Bookings', summary.totalBookings],
            ['Delivered Bookings', summary.deliveredBookings],
            ['Cancelled Bookings', summary.canceledBookings],
            ['Pending Bookings', summary.pendingBookings],
            ['Created User', summary.userCreatedCount],
            ['Total Charge', `₦${summary.totalCharge.toLocaleString()}`],
            ['Average Charge', `₦${summary.averageCharge.toLocaleString()}`],
          ],
        },
        layout: {
          fillColor: (rowIndex: number) => (rowIndex === 0 ? '#f5f5f5' : null),
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          paddingTop: () => 6,
          paddingBottom: () => 6,
          paddingLeft: () => 8,
          paddingRight: () => 8,
        },
      },

      // --- Daily Breakdown Table ---
      {
        text: 'Daily Breakdown',
        style: 'sectionTitle',
        margin: [0, 20, 0, 8],
      },
      {
        table: {
          headerRows: 1,
          widths: [
            60, // Date
            '*', // Total Bookings
            '*', // Total Charge
            '*', // Avg Charge
            '*', // Users Created
          ],
          body: [
            [
              { text: 'Date', bold: true },
              { text: 'Total Bookings', bold: true },
              { text: 'Total Charge', bold: true },
              { text: 'Avg Charge', bold: true },
              { text: 'Users Created', bold: true },
            ],
            ...(Array.isArray(dailyData)
              ? dailyData.map((row: any) => [
                  new Date(row.date).toLocaleDateString(),
                  row.totalBookings,
                  `₦${row.totalCharge.toLocaleString()}`,
                  `₦${row.averageCharge.toLocaleString()}`,
                  row.userCreatedCount,
                ])
              : []),
          ],
        },
        layout: {
          fillColor: (rowIndex: number) => (rowIndex === 0 ? '#f5f5f5' : null),
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          paddingTop: () => 6,
          paddingBottom: () => 6,
          paddingLeft: () => 8,
          paddingRight: () => 8,
        },
        margin: [0, 0, 0, 10],
      },

      // --- Breakdowns ---
      { text: 'Breakdowns', style: 'sectionTitle', margin: [0, 20, 0, 8] },
      {
        columns: [
          {
            width: '50%',
            stack: [
              {
                text: 'By Channel',
                style: 'subSectionTitle',
                margin: [0, 0, 0, 4],
              },
              {
                ul: breakdowns.byChannel.map(
                  (item: any) =>
                    `${item._id || 'N/A'} — ${
                      item.count
                    } bookings — ₦${item.totalValue.toLocaleString()}`
                ),
                margin: [0, 0, 0, 10],
              },
            ],
          },
          {
            width: '50%',
            stack: [
              {
                text: 'By Delivery Type',
                style: 'subSectionTitle',
                margin: [0, 0, 0, 4],
              },
              {
                ul: breakdowns.byDeliveryType.map(
                  (item: any) =>
                    `${item._id || 'N/A'} — ${
                      item.count
                    } bookings — ₦${item.totalValue.toLocaleString()}`
                ),
                margin: [0, 0, 0, 10],
              },
            ],
          },
        ],
      },
      {
        columns: [
          {
            width: '50%',
            stack: [
              {
                text: 'By Shipment Type',
                style: 'subSectionTitle',
                margin: [0, 10, 0, 4],
              },
              {
                ul: breakdowns.byShipmentType.map(
                  (item: any) =>
                    `${item._id} — ${
                      item.count
                    } bookings — ₦${item.totalValue.toLocaleString()}`
                ),
                margin: [0, 0, 0, 10],
              },
            ],
          },
        ],
      },

      // --- Insights: Top Users & Businesses ---
      { text: 'Top Users', style: 'sectionTitle', margin: [0, 20, 0, 8] },
      {
        columns: [
          {
            width: '50%',
            stack: [
              {
                text: 'By Count',
                style: 'subSectionTitle',
                margin: [0, 0, 0, 4],
              },
              {
                ol: insights.topUsers.byCount.map(
                  (u: any) => `${u.name} — ${u.count} bookings`
                ),
              },
            ],
          },
          {
            width: '50%',
            stack: [
              {
                text: 'By Charge',
                style: 'subSectionTitle',
                margin: [0, 0, 0, 4],
              },
              {
                ol: insights.topUsers.byCharge.map(
                  (u: any) => `${u.name} — ₦${u.totalCharge.toLocaleString()}`
                ),
              },
            ],
          },
        ],
      },

      { text: 'Top Businesses', style: 'sectionTitle', margin: [0, 20, 0, 8] },
      {
        columns: [
          {
            width: '50%',
            stack: [
              {
                text: 'By Count',
                style: 'subSectionTitle',
                margin: [0, 0, 0, 4],
              },
              {
                ol: insights.topBusinesses.byCount.map(
                  (b: any) => `${b.name} — ${b.count} bookings`
                ),
              },
            ],
          },
          {
            width: '50%',
            stack: [
              {
                text: 'By Charge',
                style: 'subSectionTitle',
                margin: [0, 0, 0, 4],
              },
              {
                ol: insights.topBusinesses.byCharge.map(
                  (b: any) => `${b.name} — ₦${b.totalCharge.toLocaleString()}`
                ),
              },
            ],
          },
        ],
      },

      {
        table: {
          widths: ['*', '*'],
          body: [
            [
              { text: 'Metric', bold: true },
              { text: 'Value', bold: true },
            ],
            ['Total Valid Bookings', summary.totalBookings],
            ['Delivered Bookings', summary.deliveredBookings],
            ['Cancelled Bookings', summary.canceledBookings],
            ['Pending Bookings', summary.pendingBookings],
            ['Created User', summary.userCreatedCount],
            ['Total Charge', `₦${summary.totalCharge.toLocaleString()}`],
            ['Average Charge', `₦${summary.averageCharge.toLocaleString()}`],
          ],
        },
        layout: {
          fillColor: (rowIndex: number) => (rowIndex === 0 ? '#f5f5f5' : null),
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          paddingTop: () => 6,
          paddingBottom: () => 6,
          paddingLeft: () => 8,
          paddingRight: () => 8,
        },
      },
    ],

    styles: {
      header: {
        fontSize: 20,
        bold: true,
        alignment: 'center',
        margin: [0, 0, 0, 16],
      },
      dateRange: {
        fontSize: 12,
        italics: true,
        alignment: 'center',
      },
      sectionTitle: {
        fontSize: 16,
        bold: true,
        decoration: 'underline',
      },
      subSectionTitle: {
        fontSize: 13,
        bold: true,
      },
    },

    defaultStyle: {
      fontSize: 11,
      lineHeight: 1.4,
    },
  }

  const fileName = from
    ? `analytics_report_From ${new Date(
        from
      ).toLocaleDateString()} to ${new Date(to).toLocaleDateString()}.pdf`
    : 'analytics_report_All_Time.pdf'

  pdfMake.createPdf(docDefinition).download(fileName)
}
